import ContactForm from '@components/Components/Contact/ContactForm';
import TypographyGridCol from '@components/Components/Reusables/TypographyGridCol';
import ContactUs from '@components/Components/Contact/ContactUs'
import BoxContainer from '@components/Components/Reusables/BoxContainerV2';
import CardContainer from '@components/Components/Reusables/CardContainer';
import Grid from '@mui/material/GridLegacy';
import Image from 'next/image';
import React from 'react'


const gridProps = {
    xs: 12,
    md: 12,
    lg: 12
}

const Brochures = (props) => {
    const {
        template_page_settings
    } = props;

    return (
        <>
            <BoxContainer className="mt-2">
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <CardContainer
                            className="p-3 mr-1"
                            elevation={2}
                        >
                            <TypographyGridCol
                                title="Brochure Request Form"
                                subtitle="Please complete this form and one of our team will get back to you shortly."
                                gridProps={gridProps}
                            >

                                <ContactForm
                                    message={false}
                                    postcode={false}
                                    brochure={true}
                                    gridProps={gridProps} {...props} />
                            </TypographyGridCol>
                        </CardContainer>
                    </Grid>
                    <Grid item lg={3} md={5} xs={12}>
                        <Grid
                            className='position-relative'
                            sx={{
                                height: '100%',
                                '@media (max-width: 900px)': {
                                    height: '500px'
                                },
                            }}
                        >
                            <Image src="/images/EH/eh-brochure-cover.jpg" fill objectFit='cover' alt='2025 EH Brochure Cover' />
                        </Grid>
                    </Grid>
                </Grid>
            </BoxContainer>
        </>
    )
}

export default Brochures